import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Warning = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/warning-2">
        <g id="warning-2">
          <path
            id="Vector"
            d="M8 9.16663C7.72667 9.16663 7.5 8.93996 7.5 8.66663V5.16663C7.5 4.89329 7.72667 4.66663 8 4.66663C8.27333 4.66663 8.5 4.89329 8.5 5.16663V8.66663C8.5 8.93996 8.27333 9.16663 8 9.16663Z"
          />
          <path
            id="Vector_2"
            d="M7.9987 11.4999C7.8187 11.4999 7.65202 11.4333 7.52535 11.3066C7.46535 11.24 7.4187 11.1666 7.3787 11.0866C7.34537 11.0066 7.33203 10.9199 7.33203 10.8333C7.33203 10.6599 7.40535 10.4866 7.52535 10.3599C7.77202 10.1133 8.22538 10.1133 8.47205 10.3599C8.59205 10.4866 8.66536 10.6599 8.66536 10.8333C8.66536 10.9199 8.64535 11.0066 8.61202 11.0866C8.57869 11.1666 8.53205 11.24 8.47205 11.3066C8.34538 11.4333 8.1787 11.4999 7.9987 11.4999Z"
          />
          <path
            id="Vector_3"
            d="M8.00142 15.1666C7.55476 15.1666 7.10142 15.0533 6.70142 14.8199L2.74141 12.5333C1.94141 12.0666 1.44141 11.2066 1.44141 10.2799V5.71995C1.44141 4.79329 1.94141 3.93328 2.74141 3.46662L6.70142 1.17996C7.50142 0.713289 8.49477 0.713289 9.30143 1.17996L13.2614 3.46662C14.0614 3.93328 14.5614 4.79329 14.5614 5.71995V10.2799C14.5614 11.2066 14.0614 12.0666 13.2614 12.5333L9.30143 14.8199C8.90143 15.0533 8.44809 15.1666 8.00142 15.1666ZM8.00142 1.83328C7.72809 1.83328 7.44808 1.90661 7.20142 2.04661L3.24141 4.33328C2.74808 4.61994 2.44141 5.14662 2.44141 5.71995V10.2799C2.44141 10.8466 2.74808 11.3799 3.24141 11.6666L7.20142 13.9533C7.69475 14.2399 8.30809 14.2399 8.79476 13.9533L12.7548 11.6666C13.2481 11.3799 13.5548 10.8533 13.5548 10.2799V5.71995C13.5548 5.15329 13.2481 4.61994 12.7548 4.33328L8.79476 2.04661C8.55476 1.90661 8.27476 1.83328 8.00142 1.83328Z"
          />
        </g>
      </g>
    </svg>
  );
};

Warning.displayName = 'Warning';
